export default {
  GN_ASSETS_BASE_URL: process.env.NEXT_PUBLIC_GN_ASSETS_BASE_URL,
};
